import React from "react";
import { SelectArrayInput, useChoicesContext } from "react-admin";

import { hasBonusExcludingTaxInYen, StoragePeriodPriceRecordWithId } from "../utils/price_calculation";

export const StoragePeriodSelectArrayInput = (props: any) => {
  const { allChoices, isLoading, resource, selectedChoices, source } = useChoicesContext();
  const selectedChoiceIds = new Set(
    ((selectedChoices ?? []) as StoragePeriodPriceRecordWithId[]).map((choice) => choice.id)
  );
  const choices = ((allChoices ?? []) as StoragePeriodPriceRecordWithId[]).filter((choice) => {
    return hasBonusExcludingTaxInYen(choice) || selectedChoiceIds.has(choice.id);
  });

  return (
    <SelectArrayInput
      {...props}
      choices={choices}
      isLoading={props.isLoading ?? isLoading}
      resource={props.resource ?? resource}
      source={props.source ?? source}
      translateChoice={props.translateChoice ?? false}
    />
  );
};
